import React from 'react';
import PropTypes from 'prop-types';

const LoadingOverlay = ({children, loading, overlayStyle, spinnerStyle, className}) => {
    return (
      <div className={className + " loading-container"}>
        {children}
        { loading ? <div id="overlay" style={overlayStyle}>
          <div className="loader" style={spinnerStyle}>
            Loading...
          </div>
        </div> : null }
        
      </div>
    );
};

LoadingOverlay.propTypes = {
  children: PropTypes.object,
  loading: PropTypes.bool,
  overlayStyle: PropTypes.object,
  spinnerStyle: PropTypes.object,
  className: PropTypes.string
};
  
export default LoadingOverlay;


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay.jsx